import React, { useState, useEffect, Fragment, useCallback } from "react";
import axios from 'axios';
import { useSelector, useDispatch } from "react-redux";
import { updateMessagesList, updateNotificationsTypeList } from "../store/notifications-slice";
import { SocketContext } from "../utils/socket-client";
import DashboardContainer from "./UI/DashboardContainer";
import Notification from "./Notification";
import MyPagination from "./UI/MyPagination";
import { variables } from "../Variables";

// MUI IMPORTS
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import ListItemText from "@mui/material/ListItemText";
import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import { Divider } from "@mui/material";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import RssFeedIcon from "@mui/icons-material/RssFeed";
import theme from "./UI/Theme";

const LiveFeeds = (props) => {
  const { selectedDatesFrom, selectedDatesTo } = props;
  const dispatch = useDispatch();
  const mySocket = React.useContext(SocketContext);

  const messagesListInitial = useSelector((state) => state.notifications.messages);
  const notificationsListInitial = useSelector((state) => state.notifications.notificationsType);

  const [socket, setSocket] = useState(null);
  const [messagesList, setMessagesList] = useState(messagesListInitial);
  const [notificationsList, setNotificationsList] = useState(notificationsListInitial);
  const [notificationsListMongo, setNotificationsListMongo] = useState([]);
  const [loading, setLoading] = useState(false);

  const matches = useMediaQuery(theme.breakpoints.down("lg"));
  const matches2 = useMediaQuery(theme.breakpoints.down("md"));
  const matches3 = useMediaQuery(theme.breakpoints.down("sm"));

  // Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage] = useState(5);

  const selectedDatesFrom_2 = new Date(selectedDatesFrom).toISOString();
  const selectedDatesTo_2 = new Date(new Date(selectedDatesTo).setHours(23, 59, 59)).toISOString();

  // --- Función de carga (Memorizada para evitar loops) ---
  const getNofificationsFromDB = useCallback(() => {
    setLoading(true);
    // CORRECCIÓN DE URL AQUÍ:
    const url = `${variables.API_URL_MONGO}/notifications/${selectedDatesFrom_2}/${selectedDatesTo_2}`;
    
    axios.get(url, { withCredentials: true })
      .then((res) => {
        setNotificationsListMongo(res.data || []);
        setLoading(false);
      })
      .catch(err => {
        console.error("Error fetching Mongo notifications:", err);
        setLoading(false);
      });
  }, [selectedDatesFrom_2, selectedDatesTo_2]);

  // Sockets
  useEffect(() => {
    setSocket(mySocket);
  }, [mySocket]);

  useEffect(() => {
    if (!socket) return;
    socket.on("getText", (data) => setMessagesList((prev) => [...prev, data.text]));
    socket.on("getNotification", (data) => setNotificationsList((prev) => [...prev, data]));
    
    return () => {
      socket.off("getText");
      socket.off("getNotification");
    };
  }, [socket]);

  // Actualizar Redux y recargar de Mongo solo cuando hay notificaciones nuevas
  useEffect(() => {
    dispatch(updateNotificationsTypeList({ notificationsList }));
    getNofificationsFromDB();
  }, [notificationsList, dispatch, getNofificationsFromDB]);

  useEffect(() => {
    dispatch(updateMessagesList({ messagesList }));
  }, [messagesList, dispatch]);

  // Ordenar notificaciones
  const notificationsListSorted = [...notificationsListMongo].sort((a, b) => {
    const dateTimeA = new Date(`${a.notificationDate} ${a.notificationTime}`);
    const dateTimeB = new Date(`${b.notificationDate} ${b.notificationTime}`);
    return dateTimeB - dateTimeA;
  });

  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const currentPosts = notificationsListSorted.slice(indexOfFirstPost, indexOfLastPost);

  const paginate = (event, value) => setCurrentPage(value);

  return (
    <Box>
      <DashboardContainer
        reportTitle="Recent Activity (Live Feeds...)"
        myMarginTop={0.1}
        icon={<RssFeedIcon sx={{ fontSize: 30, color: "#4E1721", mr: 1 }} />}
        myWidth={matches3 ? "77.7vw" : "80vw"}
        matches={matches}
        matches2={matches2}
        matches3={matches3}
        myHeight="auto"
      >
        <Box sx={{
          p: 2, display: "flex", flexDirection: "column", alignItems: "center",
          width: matches3 ? "65vw" : matches2 ? "60vw" : matches ? "50vw" : "45vw",
        }}>
          <List>
            {messagesList.map((message, index) => (
              <Fragment key={`msg-${index}`}>
                <ListItem sx={{ width: matches ? "100%" : 400 }}>
                  <ListItemAvatar>
                    <Avatar sx={{ bgcolor: "#e7dddd" }}>
                      <AccountCircleIcon sx={{ fontSize: 30, color: "#4E1721" }} />
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText primary={message} />
                </ListItem>
                <Divider />
              </Fragment>
            ))}
          </List>

          <Notification 
            notificationsList={currentPosts} 
            matches={matches} matches2={matches2} matches3={matches3} 
          />

          <MyPagination
            postsPerPage={postsPerPage}
            totalPosts={notificationsListMongo.length}
            paginate={paginate}
            matches2={matches2}
          />
        </Box>
      </DashboardContainer>
    </Box>
  );
};

export default LiveFeeds;